{
class BackInStock extends HTMLElement {
  connectedCallback() {
    ({ unavailable: this.unavailable, locale: this.locale } = JSON.parse(this.querySelector('script').textContent));
    this.productForm = document.forms[this.getAttribute('form')];
    this.variantId = this.productForm?.elements.id?.value;
    this.onChange = event => this.show(event.detail.variant?.id);
    this.productForm?.addEventListener('variant:change', this.onChange);
    this.signup = this.querySelector('form');
    this.status = this.querySelector('[role="status"]');
    this.signup.addEventListener('submit', event => this.submit(event));
    this.signup.addEventListener('change', event => {
      if (event.target.name === 'channel') this.useChannel(event.target.value);
    });
  }
  get channel() {
    return this.signup.elements.channel?.value ?? 'email';
  }
  useChannel(channel) {
    const contact = this.signup.elements.contact;
    const sms = channel === 'sms';
    contact.type = sms ? 'tel' : 'email';
    contact.autocomplete = sms ? 'tel' : 'email';
    contact.placeholder = sms ? contact.dataset.phoneLabel : contact.dataset.emailLabel;
    contact.setAttribute('aria-label', contact.placeholder);
    contact.value = '';
  }
  disconnectedCallback() {
    this.productForm?.removeEventListener('variant:change', this.onChange);
  }
  show(variantId) {
    this.variantId = variantId;
    this.hidden = !this.unavailable.includes(String(variantId));
    this.status.hidden = true;
    this.signup.elements.contact.disabled = false;
  }
  async submit(event) {
    event.preventDefault();
    const contact = this.signup.elements.contact;
    if (!contact.checkValidity()) return contact.reportValidity();
    const button = this.signup.querySelector('button');
    button.disabled = true;
    let ok = false;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}apps/splay/back-in-stock`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variantId: this.variantId, channel: this.channel, contact: contact.value, locale: this.locale }),
      });
      ok = response.ok;
    } catch {}
    // The theme's custom-button marks itself busy on every submit and only clears it on the next page load.
    button.removeAttribute('aria-busy');
    button.disabled = false;
    this.status.textContent = ok ? this.status.dataset.success : this.status.dataset.error;
    this.status.hidden = false;
    if (ok) contact.disabled = true;
  }
}
if (!customElements.get('back-in-stock')) customElements.define('back-in-stock', BackInStock);
}
